import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from 'src/app/Services/api.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserData } from 'src/app/Services/data.model';
import { ExpenseModel } from '../components/pages/expenseManagement/expenseManagement.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FeeApiService {
  odPayDomain: string = environment.odPayDomain;

  browserDomain : string = this.service.browserDomain;
  constructor(private http: HttpClient, private service: ApiService) { }


  URLAddress(address){
    const FinalURL = this.service.URLAddress(address,'fee')
    return FinalURL; 
  }
  studentIdSubject = new BehaviorSubject(null);
  ///////Other Module API......


  // private printData$: BehaviorSubject<any> = new BehaviorSubject(null);
  // getPrintData(): Observable<any> { 
  //     return this.printData$.asObservable();
  // }

  // setPrintData(data: any) {
  //     this.printData$.next(data);
  //     console.log(this.printData$ , data)
  // }


  getCourseList(entityId, session): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/course?entity=' +entityId+'&session='+session))
  }
  getCourseData(entityId): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/course?id='+entityId) );
  }
  viewFeeMasterData(entityId, session): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/feeMaster?entity=' +entityId+'&session='+session))
  }
  listCourseWiseReport( courseWiseReportData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/courseWiseCollection/feeReports'), courseWiseReportData)
  }
  listCategoryWiseReport( courseWiseReportData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/categoryWiseCollection/feeReports'), courseWiseReportData)
  }
  listFeeHeadWiseReport( courseWiseReportData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/feeHeadWiseCollection/feeReports'), courseWiseReportData)
  }
  listCombinedHeadWiseCollectionReport( courseWiseReportData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/combinedHeadWiseCollectionReport/feeReports'), courseWiseReportData)
  }
  sendDueFeeSMSCommunication( formData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/sendDueFeeSMS/communication'), formData)
  } 
  sendWhatsappSms(formData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/sendDueFeeWhatsAppWeb/communication'), formData)
  }
  sendWhatsapp(formData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/sendDueFeeWhatsApp/communication'), formData)
  }
  sendMultipleAdmissionReminderSMSCommunication( formData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/sendMultipleAdmissionReminderSMS/communication'), formData)
  } 
  sendMultipleAdmissionReminderWhstasAppSMSCommunication(formData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/sendMultipleAdmissionReminderWhatsAppWeb/communication'), formData)
  }
  sendDueFeeMSTeams( formData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/sendDueFeeMSTeams/communication'), formData)
  }

  listCommunicationTemplate(entityId, eventType, channel):Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/communicationTemplate?entity='+entityId+'&eventType='+eventType+ '&channel='+channel))
  }
  viewCommunicationConfig(entityId, session):Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/communicationConfig?entity='+entityId+'&session='+session))
  }  

  createAdjustment(formData): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/createAdjustment/transaction'), formData)
  }
  getTransactionList(formData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/getTransactions/odPay'),formData) 
  }
  geBulkRefundDeatils(formData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/getBulkFeeRefundDetails/refundTransaction'),formData) 
  }

  createBulkFeeRefund(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/createBulkFeeRefund/refundTransaction'),formData) 
  }

  retryEntityApi(row):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/retryEntityAPI/odPay'),row) 
  }
  updateStatus(row):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/updateStatus/odPay'),row) 
  }
  getSessionList(entityId): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/session?entity=' +entityId))
  }
  listTermGroups( entityId, session): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/termGroup?entity=' +entityId+ '&session=' +session));
  }
  editFeeMasterData(feeMasterData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress("/edit/feeMaster"), feeMasterData);
  }
  viewExpenseManagementMaster(entityId): Observable<ExpenseModel>{
    return this.http.get<ExpenseModel>(this.URLAddress('/view/expenseManagementMaster?entity='+entityId))
  }
  editExpenseManagementMaster(formData): Observable<ExpenseModel>{
    return this.http.post<ExpenseModel>(this.URLAddress('/edit/expenseManagementMaster'),formData)
  }
  editEntityData(entityData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress("/edit/entity"), entityData);
  }
  getConcessionGroupList(entityId, session): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/concession?entity=' +entityId+'&session='+session))
  }
  addConcessionGroup(concessionGroupData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress("/add/concession"), concessionGroupData);
  }
  viewConcessionGroup(concessionGroupId): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/concession?id='+concessionGroupId) );
  }
  editConcessionGroup(concessionGroupData): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/edit/concession'), concessionGroupData);
  }
  copyConcessionGroupFromSession(entityId,fromSession,toSession): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/copyFromSession/concession?entity='+entityId+'&fromSession='+fromSession+'&toSession='+toSession));
  }
  deleteConcessionGroup(id): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/delete/concession?id='+id) );
  }
  getFeeGroupList(entityId, session,pageNumber,pageSize,search): Observable<UserData>{
    let querParam =entityId+'&session='+session
    if(pageNumber)
    {
      querParam+='&pageNumber='+pageNumber;
    }
    if(pageSize)
    {
      querParam+='&pageSize='+pageSize;
    }
    if(search)
    {
      querParam+='&search='+search;
    }
    return this.http.get<UserData>(this.URLAddress('/list/feeGroup?entity=' + querParam))
  }
  addTerms(termsData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/add/termGroup'), termsData);
  }
  viewTermData(termId): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/termGroup?id=' +termId));
  }
  editTerms(termsData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/edit/termGroup'), termsData);
  }
  addFeeGroup(feeGroupData):Observable<any>{
    return this.http.post<any>(this.URLAddress("/add/feeGroup"), feeGroupData);
  }
  viewFeeGroup(feeGroupId): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/feeGroup?id='+feeGroupId) );
  }
  editFeeGroup(feeGroupData): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/edit/feeGroup'), feeGroupData);
  }
  deleteFeeGroup(id): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/delete/feeGroup?id='+id) );
  }
  saveMetaData(id,model,data):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/saveMetadata?id='+id+'&model='+model), data)
  }
  uploadDemandDocument(qac,formData): Observable<any>{
    return this.http.post<any>(this.URLAddress('/uploadDemandDocument?qac='+qac),formData)
  }
  updateGroupFeeHead(formData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress("/edit/feeMaster"), formData);
  }
  copyFromSessionFeeMaster(entity,fromSession,toSession): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/copyFromSession/feeMaster?entity='+entity+ '&fromSession='+ fromSession+'&toSession='+toSession))
  }
  viewAccountingMaster(entityId): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/accountingMaster?entity=' +entityId))
  } 
  checkFeeHeadInUse(entityId, session, feeHead): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/checkFeeHeadInUse/feeMaster?entity='+entityId+'&session='+session+'&feeHead='+feeHead))
  }
  viewFineConfig(entityId,id): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/fineConfig?entity=' +entityId+'&id='+id))
  }
  listFineConfig(entityId): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/fineConfig?entity=' +entityId))
  }
  editFineConfig(feeMasterData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress("/edit/fineConfig"), feeMasterData);
  }
  addFineConfig(feeMasterData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress("/add/fineConfig"), feeMasterData);
  }
  deleteBulkTransactions(entityId, session, fileData): Observable<any>{
    return this.http.post<any>(this.URLAddress('/deleteReceiptsByXL/transaction?entity=' +entityId+'&session='+session), fileData)
  }
  getCourseListAll(entityId, session): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/listAll/course?entity=' +entityId+'&session='+session))
  }
  viewAdmissionMaster(entityId, session): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/admissionMaster?entity='+entityId+ '&session='+ session))
  }
  // Receipt Settings 
  viewReceiptMaster(entityId, session, receiptSessionDependency): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/receiptMaster?entity=' +entityId+'&session='+session+'&receiptSessionDependency='+receiptSessionDependency))
  }
  editReceiptMaster(receiptMasterData):Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress("/edit/receiptMaster"), receiptMasterData);
  }

  importReceipt(entityId, session, fileData): Observable<any>{
    return this.http.post<any>(this.URLAddress('/importReceipts/transaction?entity=' +entityId+'&session='+session), fileData)
  }
  importAutoReceipt(entityId, session,sessionEndDate, fileData): Observable<any>{
    return this.http.post<any>(this.URLAddress('/importAutoReceipts/transaction?entity=' +entityId+'&session='+session+'&sessionEndDate='+sessionEndDate), fileData)
  }
  importOtherIncomeReceipts(entityId, session, fileData): Observable<any>{
    return this.http.post<any>(this.URLAddress('/importReceipts/otherIncomeTransaction?entity=' +entityId+'&session='+session), fileData)
  }
  importRefundTransactionReceipts(entityId, session, fileData): Observable<any>{
    return this.http.post<any>(this.URLAddress('/importReceipts/refundTransaction?entity=' +entityId+'&session='+session), fileData)
  }
  listSubjectCombination(entityId, session): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/subjectCombination?entity='+entityId+ '&session='+ session))
  }
  listSubject(entityId, session): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/list/subject?entity='+entityId+ '&session='+ session))
  }
  addSubjectCombination(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/add/subjectCombination'), formData)
  }
  viewSubjectCombination(id):Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/subjectCombination?id='+id))
  }
  editSubjectCombination(formData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/edit/subjectCombination'), formData)
  }
  importSubjectCombinationXl(entityId, session, fileData): Observable<any>{
    return this.http.post<any>(this.URLAddress('/importSubjectCombinationXL/subjectCombination?entity=' +entityId+'&session='+session), fileData)
  }
  uploadSubjectCombinationXl(entityId, session, fileData): Observable<any>{
    return this.http.post<any>(this.URLAddress('/uploadSubjectCombinationXL/student?entity=' +entityId+'&session='+session), fileData)
  }
  uploadSubjectMultipleCharges(entity,session,fileData): Observable<any>{
    return this.http.post<any>(this.URLAddress('/uploadMultipleSubjectChargesXL/subjectCombination?entity='+entity+'&session='+session), fileData)
  }
  copyFromSession(entity,fromSession,toSession): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/copyFromSession/subjectCombination?entity='+entity+ '&fromSession='+ fromSession+'&toSession='+toSession))
  }
  deletSubjectCombination(id): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/delete/subjectCombination?id='+id) );
  }
  makeDefaultTerm(termsData): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/makeDefault/termGroup'), termsData);
  }
  addTermCourse(termCourse): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/assignToClass/termGroup'), termCourse);
  }
  uploadDocumentLogo(qac,fileData):Observable<any>{
    return this.http.post<any>(this.URLAddress('/uploadDocument?qac='+qac),fileData);
  }
  getEntityId(entityId,branchId): Observable<any>{
    let queryParams = entityId 
  
    if(branchId){
      queryParams = queryParams + '&branchId='+branchId
    }
    return this.http.get<any>(this.odPayDomain+'/api/getEntityForERP/entity?odErpEntityId='+queryParams)
  }
  loginWithoutOTP(phone): Observable<any>{
    return this.http.post<any>(this.odPayDomain+"/loginWithoutOTP",{
      phone: phone,
    })
  }
  getDataFromODpay(odPayEntityId,regNo,erpSession): Observable<any>{
    return this.http.post<any>(this.odPayDomain+"/api/search/student",{
      entity: odPayEntityId,
      enrollmentNumber: regNo,
      erpSession:erpSession
    })
  }
  recentPaymentCheck(formData):Observable<any>{
    return this.http.post<any>(this.odPayDomain+"/api/recentPaymentCheck/payment",formData)
  }
  processPayment(formData):Observable<any>{
    return this.http.post<any>(this.odPayDomain+"/api/process/payment",formData)
  }
  viewPayment(receiptId):Observable<any>{
    return this.http.get<any>(this.odPayDomain+'/api/view/payment?id='+receiptId)
  }
  applyCharges(formData):Observable<any>{
    return this.http.post<any>(this.odPayDomain+"/api/apply/chargesCategory",formData)
  }
  checkChargesCategory(odPayEntityId, regNo, erpSession, erpTransactionType?): Observable<any> {
    let payload: any = {
      entity: odPayEntityId,
      enrollmentNumber: regNo,
      erpSession: erpSession
    };
    if (erpTransactionType) {
      payload.erpTransactionType = erpTransactionType;
    }
    return this.http.post<any>(this.odPayDomain + "/api/search/student", payload);
  }
  initiateTxn(formData):Observable<any>{
    return this.http.post<any>(this.odPayDomain+"/api/initiateTxn/payment",formData)
  }
  resetUserPasswordFromERP(userId,pass) : Observable<any>{
    return this.http.post<any>(this.odPayDomain+'/resetPasswordFromERP?userId='+userId,{
      userId:userId,
      password:pass
    })
  }
  
  viewByTxnId(txnId,entityId):Observable<any>{
    return this.http.get<any>(this.URLAddress('/viewByTxnId/transaction?txnId='+txnId+'&entity='+entityId))
  }
  viewByOnlineTxnId(txnId):Observable<any>{
    return this.http.get<any>(this.URLAddress('/viewByTxnId/otherIncomeTransaction?txnId='+txnId))
  }
  checkDuplicateRefId(data): Observable<any> {
    return this.http.post<any>(this.URLAddress('/checkDuplicateRefId/transaction'), data);
  }
  saveTransaction(payData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/saveTransaction/transaction'), payData);
  }
  saveOtherIncomeTransaction(payData):Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/saveTransaction/otherIncomeTransaction'), payData);
  }
  sendPaymentLink(formData): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/sendPaymentLink/communication'), formData)
  }
  viewTransaction(transactionId): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/transaction?id='+transactionId));
  }
  editTransaction(formData): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/edit/transaction'), formData)
  }
  editOtherIncomeTransaction(formData): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/edit/otherIncomeTransaction'), formData)
  }
  viewStudentData(studentId, entityId, session, regNo): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/student?id='+studentId+ '&entity=' +entityId+'&session='+session+ '&regNo='+regNo) );
  }
  checkStudentDues(studentId): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/checkDues/student?id='+studentId) );
  }
  checkAllSessionDues(entityId, regNo,): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/checkAllSessionDues/student?entity='+entityId+'&regNo='+regNo));
  }
  viewStudentFeeData(data): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/getStudentFeeData/transaction'), data);
  }
  searchStudentFeeAllSession(entity,name): Observable<UserData[]>{
    return this.http.get<UserData[]>(this.URLAddress('/searchStudentDetails/student?entity='+entity +'&search='+name) );
  }
  searchByStudent(name, entityId, session,searchBy): Observable<UserData[]>{
    let queryParms = name+ '&entity=' +entityId+ '&session=' +session;
    if(searchBy){
      queryParms = queryParms+'&searchBy=' + searchBy;
    }
    return this.http.get<UserData[]>(this.URLAddress('/search/student?search='+ queryParms) );
  }
  searchByStudentWithCourse(name, entityId, session,searchBy,course): Observable<UserData[]>{
    let queryParms = name+ '&entity=' +entityId+ '&session=' +session;
    if(searchBy){
      queryParms = queryParms+'&searchBy=' + searchBy;
    }
    return this.http.post<UserData[]>(this.URLAddress('/search/student?search='+ queryParms),{course:course} );
  }
  fetchStudentId(entityId,session,regNo): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/fetchStudentByRegNo/student?entity='+entityId +'&session='+session+'&regNo='+regNo) );
  }
  listExcelTemplate(entity,report):Observable<any[]>{
    let queryParams = entity
    if(report)
    {
      queryParams+='&report='+report
    }
    return this.http.get<any[]>(this.URLAddress('/list/excelTemplate?entity='+queryParams))
  }
  viewExcelTemplate(id): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/excelTemplate?id='+id) );
  }
  viewDefaultExcelTemplates(report,entityType): Observable<UserData>{
    let queryParams
    if(report)
    {
      queryParams+='&report='+report
    }
    if(entityType)
    {
      queryParams+='&entityType='+entityType
    }
    return this.http.get<UserData>(this.URLAddress('/viewDefault/defaultExcelTemplate?report='+report+'&entityType='+entityType) );
  }
  searchEmployee(name, entityId, session): Observable<UserData[]> {
    return this.http.get<UserData[]>(this.URLAddress('/search/employee?search=' + name + '&entity=' + entityId + '&session=' + session));
  }
  listDailyFeeReport(formData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/dailyFeeReport/feeReports'),formData)
  }
  listDueFeeReport( dueFeeReportData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/dueFeeReport/feeReports'), dueFeeReportData)
  }
  listMultiSessiontDueFeeReport( multiSessionDueFeeReportData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/multiSessionDueFeeReport/feeReports'), multiSessionDueFeeReportData)
  }
  listConcessionReport( concessionReportData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/concessionReport/feeReports'), concessionReportData)
  }
  listDailyFeeHeadCollectionReport(formData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/dailyFeeHeadCollection/feeReports'),formData)
  }
  listDailyPaymentModeCollectionReport(formData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/dailyPaymentModeCollection/feeReports'),formData)
  }
  listCombinedDailyCollectionReport(formData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/combinedDailyCollectionReport/feeReports'),formData)
  }
  listConcessionUtilizationReport( formData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/concessionUtilizationReport/feeReports'), formData)
  }
  viewHostelMaster(id):Observable<any>{
    return this.http.get<any>(this.URLAddress('/view/hostelMaster?entity='+id))
  }
  sendDueFeeNotification(formData):Observable<any>{
    return this.http.post<any>((this.URLAddress('/sendDueFee/notifications')),formData)
  }
  getCoursesByTeacher(entityId, session, attendanceType,teacher,isAdmin): Observable<UserData[]>{
    let queryParams = entityId+ '&session='+session+'&teacher='+teacher+ '&attendanceType='+attendanceType
    if(isAdmin){
      queryParams = queryParams + '&isAdmin='+isAdmin
    } 
    return this.http.get<UserData[]>(this.URLAddress('/getCoursesByTeacher/subjectCourseMapping?entity='+queryParams))
  }
  getUniqueCourseBatchCombinations(formData): Observable<any>{
    return this.http.post<any>(this.URLAddress('/getUniqueCourseBatchCombinations/subjectCourseMapping'), formData)
  }
  getDataFromODpayOtherIncome(odPayEntityId,regNo,erpSession): Observable<any>{
    return this.http.post<any>(this.odPayDomain+"/api/search/student",{
      entity: odPayEntityId,
      enrollmentNumber: regNo,
      erpSession:erpSession,
      erpTransactionType:"otherIncome" 
    })
  }
  cancelOtherIncomeReceipt(receiptData): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/cancelReceipt/otherIncomeTransaction'),receiptData);
  }
  listOtherIncomeTransaction(entityId, session, startDate, endDate, status, search, pageNumber, pageSize,voucherStatus): Observable<UserData[]>{
    let queryParms = entityId
    if(session)
    {
      queryParms+= '&session=' +session;
    }
   
    if(search){
      queryParms = queryParms + '&search=' +search;
    }
    if(startDate){
      queryParms = queryParms + '&startDate=' +startDate;
    }
    if(endDate){
      queryParms = queryParms + '&endDate=' +endDate;
    }
    if(status){
      queryParms = queryParms + '&status=' +status;
    }
    if(pageNumber){
      queryParms = queryParms + '&pageNumber=' +pageNumber;
    }
    if(pageSize){
      queryParms = queryParms + '&pageSize=' +pageSize;
    }
    if(voucherStatus)
    {
      queryParms = queryParms + '&voucherStatus=' + voucherStatus;
    }
    return this.http.get<UserData[]>(this.URLAddress('/list/otherIncomeTransaction?entity=' +queryParms))
  }
  listStudentTransaction(entityId, session, startDate, endDate, status, search, studentId): Observable<UserData[]>{
    let queryParms = entityId+ '&session=' +session + '&student=' + studentId;
    if(search){
      queryParms = queryParms + '&search=' +search;
    }
    if(startDate){
      queryParms = queryParms + '&startDate=' +startDate;
    }
    if(endDate){
      queryParms = queryParms + '&endDate=' +endDate;
    }
    if(status){
      queryParms = queryParms + '&status=' +status;
    }
    return this.http.get<UserData[]>(this.URLAddress('/list/transaction?entity=' +queryParms))
  }
  deleteTransaction(transactionId): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/delete/transaction?id='+transactionId));
  }
  viewOtherIncomeTransaction(transactionId): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/view/otherIncomeTransaction?id='+transactionId));
  }
  cancelReceipt(receiptData): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/cancelReceipt/transaction'),receiptData);
  }
  cancelRefundReceipt(receiptData): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/cancel/refundTransaction'),receiptData);
  }
  retryOtherIncomeVoucher(id): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/reCreate/accountingVoucher?id='+id+'&txnType=otherIncome'));
  }
  
getRefundDetails(studentId,refundType): Observable<UserData>{
  return this.http.get<UserData>(this.URLAddress('/getRefundDetails/refundTransaction?studentId='+studentId +'&refundType='+refundType) );
 }
saveRefundDetails(refundData): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/saveTransaction/refundTransaction'), refundData);
   }
 listRefundTransaction(entityId, session, startDate, endDate, status, search, pageNumber, pageSize,id,voucherStatus, courses?: any): Observable<UserData[]>{
  let queryParms = entityId+ '&session=' +session;
  if(search){
    queryParms = queryParms + '&search=' +search;
  }
  if(startDate){
    queryParms = queryParms + '&startDate=' +startDate;
  }
  if(endDate){
    queryParms = queryParms + '&endDate=' +endDate;
  }
  if(status){
    queryParms = queryParms + '&status=' +status;
  }
  if(pageNumber){
    queryParms = queryParms + '&pageNumber=' +pageNumber;
  }
  if(pageSize){
    queryParms = queryParms + '&pageSize=' +pageSize;
  }
  if(id){
    queryParms = queryParms+'&student='+id;
  }
  if(voucherStatus)
  {
    queryParms = queryParms+'&voucherStatus=' + voucherStatus;
  }
  let body: any = null;
  if (courses && courses.length > 0) {
    body = { course: courses };
  }
  return this.http.post<UserData[]>(this.URLAddress('/list/refundTransaction?entity=' +queryParms), body);
} 

viewRefundTransaction(transactionId): Observable<UserData>{
  return this.http.get<UserData>(this.URLAddress('/view/refundTransaction?id='+transactionId));
}

editRefundTransaction(formData): Observable<UserData>{
  return this.http.post<UserData>(this.URLAddress('/edit/refundTransaction'), formData);
}

deleteRefundTransactionListReceipt(id): Observable<UserData>{
  return this.http.get<UserData>(this.URLAddress('/delete/refundTransaction?id='+id));
}
searchStudent(name, entityId, session): Observable<UserData[]>{
  return this.http.get<UserData[]>(this.URLAddress('/search/student?search='+name +'&entity=' +entityId+'&session='+session) );
}
listAdmissionStudentData(formData): Observable<UserData>{
  // let queryParams = entityId +'&session='+session;
  
  // if(search){
  //   queryParams = queryParams + '&search='+search
  // }
  // if(pageSize){
  //   queryParams = queryParams + '&pageSize='+pageSize
  // }
  // if(pageNumber){
  //   queryParams = queryParams + '&pageNumber='+pageNumber
  // }

  return this.http.post<UserData>(this.URLAddress('/list/admissionStudentData'),formData)
}
retryTRefundTransactionVoucher(id): Observable<UserData>{
  return this.http.get<UserData>(this.URLAddress('/reCreate/accountingVoucher?id='+id+'&txnType=refund'));
}
listTransaction(formData): Observable<UserData[]>{
  // let queryParms = entityId
  // if(session){
  //   queryParms = queryParms+'&session=' +session;
  // }
  // if(search){
  //   queryParms = queryParms + '&search=' +search;
  // }
  // if(startDate){
  //   queryParms = queryParms + '&startDate=' +startDate;
  // }
  // if(endDate){
  //   queryParms = queryParms + '&endDate=' +endDate;
  // }
  // if(status){
  //   queryParms = queryParms + '&status=' +status;
  // }
  // if(pageNumber){
  //   queryParms = queryParms + '&pageNumber=' +pageNumber;
  // }
  // if(pageSize){
  //   queryParms = queryParms + '&pageSize=' +pageSize;
  // }
  // if(voucherStatus){
  //   queryParms = queryParms + '&voucherStatus=' + voucherStatus
  // }
  // if(studentRegNo){
  //   queryParms = queryParms + '&studentRegNo=' +studentRegNo
  // }
  // if(receiptId){
  //   queryParms = queryParms +'&receiptId=' + receiptId;
  // }
  // if(courses)
  // {
  //   queryParms = queryParms +'&courses='+courses
  // }
  return this.http.post<UserData[]>(this.URLAddress('/list/transaction'),formData)
}
retryTransactionVoucher(id): Observable<UserData>{
  return this.http.get<UserData>(this.URLAddress('/reCreate/accountingVoucher?id='+id+'&txnType=fee'));
}
listVehicleRoute(entityId, session): Observable<UserData[]>{
  return this.http.get<UserData[]>(this.URLAddress('/list/vehicleRoute?entity='+entityId+ '&session=' +session))
}
viewDefaultTemplate(entity,name,course):Observable<any>{
  let queryParams = entity+'&report='+name
  if(course){
    queryParams+='&course='+encodeURIComponent(course)
  }
  return this.http.get<any>(this.URLAddress('/viewDefault/pdfTemplate?entity='+queryParams));
}
viewPDFDefaultTempaltes(entityType,reportName): Observable<UserData>{
  return this.http.get<UserData>(this.URLAddress('/viewDefault/defaultPDFTemplate?report='+reportName+'&entityType='+entityType));
}
feeRegisterStudentWise(formData): Observable<UserData[]>{
  return this.http.post<UserData[]>(this.URLAddress('/studentWiseFeeRegister/feeReports'),formData)
}

  sendOtp(mobile): Observable<UserData>{
    return this.http.get<UserData>(this.URLAddress('/sendLogin/otp?mobile='+mobile))
  }
  resendOtp(mobile,value): Observable<UserData>{
    let querParam = mobile;
    if(value=='call')
    {
      querParam+='&retryType=Default';
    }
    return this.http.get<UserData>(this.URLAddress('/resend/otp?mobile='+querParam))
  }
  verifyOtp(mobile, otp, source): Observable<any>{
    return this.http.get<any>(this.URLAddress('/verify/otp?mobile='+mobile+'&otp='+otp+ '&source='+source))
  }
  changePasswd(formData):Observable<any>{
    return this.http.post<any>((this.URLAddress('/changePassword/otp')),formData)
  }
  listDailyTransportCollection(formData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/dailyTransportCollection/feeReports'), formData)
  }
  listMonthWiseCollectionReport(formData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/monthWiseFeeHeadCollection/feeReports'), formData)
  }
  listFeeHeadRegisterReport(formData): Observable<UserData[]>{
    return this.http.post<UserData[]>(this.URLAddress('/feeHeadRegister/feeReports'), formData)
  }
  getStudentExtraAmount(formData):Observable<any>{
    return this.http.post<any>((this.URLAddress('/getStudentExtraFee/student')),formData)
  }

  getBranchIdList(entity):Observable<any>{
    return this.http.get<any>(this.URLAddress('/getDistinctBranchIds/course?entity='+entity))
  }
  deleteOtherIncomeTxn(id): Observable<any>{
    return this.http.get<any>((this.URLAddress('/delete/otherIncomeTransaction?id='+id)))
  }
  fetchStudentDemandForUpdate(formData): Observable<UserData>{
    return this.http.post<UserData>(this.URLAddress('/fetchStudentDemandForUpdate/student'), formData)
  }
    updateStudentDemandAmountByExcel(formData: FormData, params: any): Observable<any> {
    const queryString = Object.keys(params).map(key => key + '=' + encodeURIComponent(params[key])).join('&');
    return this.http.post<any>(this.URLAddress('/updateStudentDemandAmountXL/student?' + queryString), formData);
  }
    updateStudentDemandAmount(formData): Observable<any> {
    return this.http.post<any>(this.URLAddress('/updateStudentDemandAmount/student'), formData);
  }
}
